import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const PILESTATUS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.PileStatus.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.PileStatus.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const PILESTATUS_CONFIG = {
  entityName: 'PileStatus',
  localizationKey: 'Planning::Entity.PileStatus',
  fields: PILESTATUS_FIELDS,
  permission: 'PlanningLocation.PileStatuses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
